var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "p-1" }, [
    _c(
      "div",
      { staticClass: "d-flex flex-row mb-1" },
      [
        _c("profile-avatar", {
          staticClass: "changelog-profile-picture",
          attrs: {
            username: _vm.changelog.username,
            "given-name": _vm.changelog.firstName,
            "family-name": _vm.changelog.lastName,
            "profile-photo": _vm.changelog.profilePhoto,
            "photo-version": _vm.changelog.photoVersion,
          },
        }),
        _vm._v(" "),
        _c("div", { staticClass: "d-flex flex-column ml-4 pt-1" }, [
          _c("p", { staticClass: "mb-0 pr-1" }, [
            _vm._v(
              "\n        " +
                _vm._s(
                  _vm.changelog.type !== "insurance-submission"
                    ? _vm.changelogName
                    : ""
                ) +
                "\n        "
            ),
            _c("span", { domProps: { innerHTML: _vm._s(_vm.changelogText) } }),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "tiny-f mb-0" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm._f("formatDateHour")(_vm.changelog.timestamp)) +
                "\n      "
            ),
          ]),
        ]),
      ],
      1
    ),
    _vm._v(" "),
    _vm._m(0),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex-grow-1" }, [
      _c("hr", { staticClass: "m-0" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }